import { Component, OnInit, OnDestroy } from '@angular/core'
import { Router, NavigationEnd, NavigationStart } from '@angular/router'
import { takeUntil, Subject } from 'rxjs'
import { KeySystem, Structure } from '../../../models/dev.test.models'
import { KeyingStructureService } from '../../../services/keying.structure.service'
import { KeyingSystemService } from '../../../services/keying.system.service'
import { AppRoutingConfig } from '../../../configuration/app.routing.config'
import { KeyingDataSetsService } from '../../../services/keying.data.sets.service'
import { NewKeySystemDialogComponent } from '../../../dialogs/new-key-system-dialog/new-key-system-dialog.component'
import { MatDialog } from '@angular/material/dialog'

@Component({
    selector: 'app-bread-crumbs',
    templateUrl: './bread-crumbs.component.html',
    styleUrls: ['./bread-crumbs.component.scss'],
    standalone: false
})
export class BreadCrumbsComponent implements OnInit, OnDestroy {
  destroy = new Subject<boolean>()
  breadCrumbs: Array<string>
  structure: Structure
  keySystem: KeySystem

  constructor(
    private router: Router,
    private keyingStructureService: KeyingStructureService,
    private keyingSystemService: KeyingSystemService,
    private keyingDataSetsService: KeyingDataSetsService,
    private dialog: MatDialog
  ) {}

  /* istanbul ignore next */
  ngOnInit(): void {
    this.breadCrumbs = this.router.url.split('/').filter((b) => b)

    this.router.events.pipe(takeUntil(this.destroy)).subscribe((observer) => {
      if (observer instanceof NavigationEnd) {
        this.breadCrumbs = observer.urlAfterRedirects.split('/').filter((b) => b)
        this.removeQueryParams()
        this.SwitchOutStructureId()
        this.SwitchKeySystemId()
      }
    })

    this.keyingStructureService.structure$.pipe(takeUntil(this.destroy)).subscribe((structure: Structure) => {
      this.breadCrumbs = this.router.url.split('/').filter((b) => b)
      this.removeQueryParams()
      this.structure = structure
      this.SwitchOutStructureId()
      this.SwitchKeySystemId()
    })

    this.keyingSystemService.keySystem$.pipe(takeUntil(this.destroy)).subscribe((keySystem: KeySystem) => {
      this.breadCrumbs = this.router.url.split('/').filter((b) => b)
      this.removeQueryParams()
      this.keySystem = keySystem
      this.SwitchOutStructureId()
      this.SwitchKeySystemId()
    })
  }

  /* istanbul ignore next */
  removeQueryParams() {
    this.breadCrumbs.forEach((breadCrumb, index) => {
      const updatedBreadCrumb = breadCrumb.split('?')[0]
      this.breadCrumbs[index] = updatedBreadCrumb
    })
  }

  /* istanbul ignore next */
  SwitchOutStructureId() {
    if (this.structure) {
      this.breadCrumbs.forEach((breadCrumb, index) => {
        if (breadCrumb === this.structure.id.toString()) {
          this.breadCrumbs[index] = this.structure.name
        }
      })
    }
  }

  /* istanbul ignore next */
  ResetStructureId() {
    if (this.structure) {
      this.breadCrumbs.forEach((breadCrumb, index) => {
        if (breadCrumb === this.structure.name) {
          this.breadCrumbs[index] = this.structure.id.toString()
        }
      })
    }
  }

  /* istanbul ignore next */
  SwitchKeySystemId() {
    if (this.keySystem) {
      this.breadCrumbs.forEach((breadCrumb, index) => {
        if (breadCrumb === this.keySystem.id.toString()) {
          this.breadCrumbs[index] = this.keySystem.topMasterKeyName
        }
      })
    }
  }

  /* istanbul ignore next */
  ngOnDestroy() {
    this.destroy.next(true)
    this.destroy.unsubscribe()
  }

  /* istanbul ignore next */
  public goTo(index: number) {
    this.ResetStructureId()
    this.keyingDataSetsService.loadKeyingDataSets()

    const breadcrumb = this.breadCrumbs
    const route = breadcrumb.slice(0, index + 1)

    this.router.navigate(route)
  }

  /* istanbul ignore next */
  selectKeySystem(keySystem) {
    if (this.breadCrumbs[this.breadCrumbs.length - 1] === this.keySystem.topMasterKeyName) {
      console.log(AppRoutingConfig.getStructureUrl(this.structure.id, keySystem.id))
      this.router.navigate([AppRoutingConfig.getStructureUrl(this.structure.id, keySystem.id)])
      this.keyingDataSetsService.loadKeySystemDataSets(this.structure.id, keySystem.id)
    } else {
      this.router.navigate([
        AppRoutingConfig.getStructureUrl(this.structure.id, keySystem.id) +
          '/' +
          this.breadCrumbs[this.breadCrumbs.length - 1],
      ])
      this.keyingDataSetsService.loadKeySystemDataSets(this.structure.id, keySystem.id)
    }
    this.keyingSystemService.selectKeySystem(keySystem)
  }

  /* istanbul ignore next */
  openDialog(): void {
    const dialogRef = this.dialog.open(NewKeySystemDialogComponent, {
      panelClass: 'phx-dialog-container',
      data: this.structure,
    })

    dialogRef.afterClosed().subscribe((data) => {
      if (data) {
        this.createKeySystem(data)
      }
    })
  }

  /* istanbul ignore next */
  createKeySystem(data) {
    data.structure = this.structure
    this.keyingStructureService.createKeySystem(data)
  }
}
